







import { Component, Vue } from 'vue-property-decorator'
import { projectListLocalisationKeys } from '@/features/projectList/projectList.localisation'

@Component
export default class ProjectListHeader extends Vue {
  private translations = projectListLocalisationKeys
}
